import classNames from 'classnames';
import { memo, type FC } from 'react';
import { Flex, Typography, Skeleton } from 'antd';

import StatusIcon from './StatusIcon';
import s from './styles.module.scss';
import { useButtons } from './use-buttons';

const { Text } = Typography;

const OverviewDashboardStatusCountFilter: FC = () => {
  const { buttons, isLoading } = useButtons();

  return (
    <div className={s.wrapper}>
      {buttons.map(({ active, count, status, label, onClick }) => {
        return (
          <button
            className={classNames(s.card, { [s.active]: active })}
            onClick={onClick}
            key={label}
            data-status={status}
          >
            <Flex align="center" gap={16} className={s.content}>
              {isLoading ? (
                <>
                  <Skeleton.Avatar active size={64} shape="circle" />
                  <Flex
                    align="center"
                    justify="space-between"
                    className={s.info}
                  >
                    <Skeleton.Input active size="small" />
                    <Skeleton.Input active size="small" />
                  </Flex>
                </>
              ) : (
                <>
                  <StatusIcon status={status} />
                  <Flex
                    flex={1}
                    align="center"
                    justify="space-between"
                    className={s.info}
                  >
                    <Text className={s.label}>{label}</Text>
                    <Text className={classNames(s.count, s[`count-${status}`])}>
                      {count}
                    </Text>
                  </Flex>
                </>
              )}
            </Flex>
          </button>
        );
      })}
    </div>
  );
};
export default memo(OverviewDashboardStatusCountFilter);
